<template>
  <div class="players">
    <h2>{{ t('innerpage.pro_players') }}</h2>

    <div class="players__grid">
      <div
        v-for="player in props.players"
        :key="player.id"
        class="players__item"
      >
        <nuxt-link
          :aria-label="player.nick_name"
          :to="localePath(`/pro-players/${player.nick_name}`)"
          class="players__item__link"
        />
        <div class="players__item__avatar">
          <img
            :alt="player.nick_name"
            :src="getImageFromProxy(player.avatar || '', '100:100')"
            loading="lazy"
          >
        </div>
        <p class="players__item__name">
          {{ player.nick_name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemPageProPlayer } from '~/graphql/generated/schema-types';

const props = defineProps<{
  players: ItemPageProPlayer[]
}>();
const { t } = useI18n();
const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.players {
  margin-top: 36px;

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 12px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    position: relative;

    &:hover {
      .players__item__avatar img {
        transform: scale(1.1);
      }

      .players__item__name {
        color: var(--surfaces-on-surface);
      }
    }

    &__link:after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
    }

    &__avatar {
      width: 100%;
      //height: 60px;
      border-radius: 50%;
      overflow: hidden;
      background: var(--surfaces-high-container);
      padding: 5px 5px 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }
    }

    &__name {
      color: var(--surfaces-on-surface-variable);
      text-align: center;
      font-kerning: none;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
      transition: color 0.3s ease;
    }
  }
}
</style>
